export type ConsentCategories = {
  necessary: true;
  analytics: boolean;
};

export type ConsentState = ConsentCategories & {
  timestamp: string;
};

const STORAGE_KEY = 'bf_cookie_consent';
export const CONSENT_CHANGE_EVENT = 'bf-consent-change';
export const OPEN_CONSENT_SETTINGS_EVENT = 'bf-open-consent-settings';

/**
 * Liest die aktuell gespeicherte Consent-Entscheidung aus dem localStorage.
 * Gibt `null` zurück, wenn der Nutzer noch keine Entscheidung getroffen hat.
 */
export const getConsent = (): ConsentState | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw) as ConsentState;
  } catch {
    return null;
  }
};

/**
 * Speichert die Consent-Entscheidung und informiert die Anwendung
 * (z. B. um Google Analytics nachträglich zu laden) per Custom Event.
 */
export const saveConsent = (categories: Omit<ConsentCategories, 'necessary'>): void => {
  const state: ConsentState = {
    necessary: true,
    analytics: categories.analytics,
    timestamp: new Date().toISOString(),
  };

  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  window.dispatchEvent(new CustomEvent(CONSENT_CHANGE_EVENT, { detail: state }));
};

export const hasAnalyticsConsent = (): boolean => {
  const consent = getConsent();
  return !!consent?.analytics;
};

/**
 * Öffnet den Consent-Dialog erneut (z. B. über den Footer-Link "Cookie-Einstellungen").
 */
export const openConsentSettings = (): void => {
  window.dispatchEvent(new Event(OPEN_CONSENT_SETTINGS_EVENT));
};
